export default __webpack_public_path__ + "static/media/pairs.1fca486a.png";